import {
    AfterViewInit,
    Directive,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";
import { Subject } from "rxjs";
import { ValidationRuleController } from "../../validation/ValidationRuleController";
import { ValidationMessageComponent } from "../../validation/validation-message/validation-message.component";
import { BaseComponent } from "./base.component";

@Directive()

export class ControlValueAccessorBaseComponent<T = any> extends BaseComponent implements OnInit, OnDestroy, AfterViewInit, ControlValueAccessor {

    privateValue: T;

    get value(): T {
        return this.privateValue;
    }

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("value")
    set value(val: T) {
        this.validate(this.privateValue, val);
        this.beforeChange.emit({
            oldValue: this.privateValue,
            newValue: val,
            component: this
        });
        this.privateValue = val;
        this.triggerChanges();
    }

    @ViewChild(ValidationMessageComponent) validationComponent: ValidationMessageComponent;

    // eslint-disable-next-line @angular-eslint/no-output-native, @angular-eslint/no-output-rename
    @Output("change") change = new EventEmitter();
    // eslint-disable-next-line @angular-eslint/no-output-native, @angular-eslint/no-output-rename
    @Output("focus") focus = new EventEmitter();
    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("beforeChange") beforeChange = new EventEmitter<{ oldValue: any; newValue: any; component: ControlValueAccessorBaseComponent }>();

    @Input() clearOnDestroy: boolean;
    @Input() rule: ValidationRuleController;
    protected readonly destroy$ = new Subject<void>();
    @Input() formatter = (val: any) => val;

    onChange: any = () => {
        // Metoden måste finnas, även om den är tom, för att resterande kod ska lira som önskat
    };
    onChangeLocal: any = () => {
        // Metoden måste finnas, även om den är tom, för att resterande kod ska lira som önskat
    };
    onTouched: any = () => {
        // Metoden måste finnas, även om den är tom, för att resterande kod ska lira som önskat
    };

    ngOnInit() {
        super.ngOnInit();
    }

    registerOnChange = (fn: any) => this.onChange = fn;
    registerOnTouched = (fn: any) => this.onTouched = fn;
    setDisabledState = (isDisabled: boolean) => this.disabled = isDisabled;

    triggerChanges() {
        this.onChange(this.formatter(this.privateValue));
        this.onChangeLocal(this.privateValue);
        this.onTouched();
        this.change.emit(this.formatter(this.privateValue));
    }

    writeValue(value: any): void {
        if (value !== undefined) {
            this.privateValue = value;
        }
    }

    linkValidationMessage() {
        if (!this.validationComponent || !this.rule) {
            return;
        }

        this.validationComponent.direct = true;
    }

    validateOnLoad() {
        if (this.rule && this.rule.rules.some(r => r.settings.triggerOnLoad)) {
            this.validate(this.privateValue, this.privateValue);
        }
    }

    validate(oldValue, newValue) {
        if (!this.rule) {
            return;
        }
        if (!this.validationComponent) {
            this.rule.validateValue(oldValue, newValue);
        } else {
            this.validationComponent.validateValue(this.formatter(oldValue), this.formatter(newValue));
        }
    }

    ngAfterViewInit(): void {
        this.linkValidationMessage();
        this.validateOnLoad();
    }

    ngOnDestroy(): void {
        if (this.clearOnDestroy) {
            this.value = undefined;
        }
        this.destroy$.next();
        this.destroy$.complete();
    }
}
